
import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import { useMeta } from 'vue-meta';
import { GameUtils } from "@/utils/GameUtils";
import router from "@/router";

export default defineComponent({
  name: "viewGamerFavourites",
  setup() {
    let totalGames;
    const pages = ref(20);
    const currentPage = ref(1);
    const totalPages = ref(0);
    const route = useRoute();
    const store = useStore();
    const userObj = store.getters['auth/user'];
    const label = computed(() => {
      return store.getters['config/configLabel'];
    });
    const metaTitle = ref('MetaXar Gamer Favourites');
    const metaDescription = ref('MetaXar Gamer Favourites Description');
    useMeta({ title: metaTitle.value, description: metaDescription.value });
    const games = ref([]);
    const invitedgames = ref([]);
    const displayGames = ref([]);
    const invitedGames = ref([]);
    const displayInvitedGames = ref([]);
    const assetURL = computed(() => {
      return store.getters['config/assetUrl'];
    });
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    (async () => {
      const favouriteGame = await GameUtils.fetchFavouriteGame();
      if(!favouriteGame) {
          router.push('/invalid-user-id');
        }
      games.value = favouriteGame;
      displayGames.value = games.value;
      totalGames = games.value.length;
      totalPages.value = Math.ceil(totalGames / pages.value);
      displayGames.value = games.value.slice(
        (currentPage.value - 1) * pages.value,
        Number((currentPage.value - 1) * pages.value) + Number(pages.value)
      );
    })()

    const loadGames = () => {
      totalPages.value = Math.ceil(games.value.length / pages.value);
      displayGames.value = games.value.slice(
        (currentPage.value - 1) * pages.value,
        Number((currentPage.value - 1) * pages.value) + Number(pages.value)
      );
    };
    loadGames();

    const enableFirstPage = computed(() => {
      return currentPage.value > 1;
    });

    const enablePreviousPage = computed(() => {
      return currentPage.value > 1;
    });

    const enableNextPage = computed(() => {
      return totalPages.value - currentPage.value > 0;
    });

    const enableLastPage = computed(() => {
      return currentPage.value < totalPages.value;
    });

    const naviFirst = () => {
      currentPage.value = 1;
      loadGames();
    };

    const naviPrevious = () => {
      --currentPage.value;
      loadGames();
    };

    const naviNext = () => {
      ++currentPage.value;
      loadGames();
    };

    const naviLast = () => {
      currentPage.value = totalPages.value;
      loadGames();
    };

    const changeRows = () => {
      loadGames();
    };

    return {
      userObj,
      games,
      label,
      assetURL,
      displayGames,
      invitedGames,
      displayInvitedGames,
      pages,
      currentPage,
      totalPages,
      enableFirstPage,
      enablePreviousPage,
      enableNextPage,
      enableLastPage,
      naviFirst,
      naviPrevious,
      naviNext,
      naviLast,
      changeRows,
    }
  }
});
